var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TemplateSummaryPopover,{attrs:{"target":_vm.target,"template":_vm.template}},[_c(_setup.TemplateSummary,{attrs:{"template":_vm.template}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }